import styled, { ColorsTypes } from 'styled-components';

import { Flex, ButtonIcon, Typography } from 'components';

const CustomButtonIcon = styled((props) => <ButtonIcon {...props} />)`
  flex-shrink: 0;
`;

const ButtonGroup = styled((props) => <Flex {...props} />)`
  flex-wrap: nowrap;
  border: 1px solid ${({ theme }) => theme.colors.gray_200};
  border-radius: 4px;

  &:first-child {
    ${CustomButtonIcon} {
      border-top-left-radius: 2px;
      border-bottom-left-radius: 2px;
    }
  }

  &:last-child {
    ${CustomButtonIcon} {
      border-top-right-radius: 2px;
      border-bottom-right-radius: 2px;
    }
  }
`;

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  setPage: (page: number) => void;
  linkColor?: ColorsTypes;
}

const Pagination = ({ currentPage, totalPages, linkColor = 'primary_400', setPage }: PaginationProps) => {
  return (
    <Flex height={39}>
      <ButtonGroup>
        <Flex>
          <CustomButtonIcon
            icon="chevronLeft"
            width={39}
            iconWidth={22}
            bg="white"
            bgHover="gray_100"
            color={currentPage > 1 ? linkColor : 'gray_200'}
            justifyContent="center"
            disabled={currentPage <= 1}
            onClick={() => {
              setPage(currentPage - 1);
            }}
          />
        </Flex>

        <Flex bg="gray_100" borderLeft="2px solid" borderRight="2px solid" borderColor="gray_200" alignItems="center">
          <Typography px={3} type="type0" color="gray_500" style={{ whiteSpace: 'nowrap' }}>
            {currentPage}
            {' de '}
            {totalPages}
          </Typography>
        </Flex>

        <Flex>
          <CustomButtonIcon
            icon="chevronRight"
            width={39}
            iconWidth={22}
            bg="white"
            bgHover="gray_100"
            color={currentPage < totalPages ? linkColor : 'gray_200'}
            justifyContent="center"
            disabled={currentPage >= totalPages}
            onClick={() => {
              setPage(currentPage + 1);
            }}
          />
        </Flex>
      </ButtonGroup>
    </Flex>
  );
};

export default Pagination;
